import useUser from '../../../user';

/*
  Sends a link to the currently logged in user asking them to verify their email address.
*/
const useVerifyEmail = () => {
  const { sendEmailVerificationLink } = useUser();

  const issueVerifyEmailLink = async () => {
    // see https://firebase.google.com/docs/auth/web/manage-users#send_a_user_a_verification_email
    return sendEmailVerificationLink();
  };

  return {
    issueVerifyEmailLink
  };
};

export default useVerifyEmail;
